export default ".demo-jing-sticky {\n    height: 300vh;\n    overflow: initial;\n    .jing-demo__content {\n        height: 100vh;\n    }\n}"